import React from "react";
import { Location } from "@reach/router";

let scrollPositions = {};

class ManageScrollImpl extends React.Component {
  componentDidMount() {
    try {
      // session storage will throw for a few reasons
      // - user settings
      // - in-cognito/private browsing
      // - who knows...
      let storage = JSON.parse(sessionStorage.getItem("scrollPositions"));
      if (storage) {
        scrollPositions = JSON.parse(storage) || {};
        let { key } = this.props.location;
        if (scrollPositions[key]) {
          window.scrollTo(0, scrollPositions[key]);
        }
      }
    } catch (e) {}

    window.addEventListener("scroll", this.listener);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listener);
  }

  componentDidUpdate() {
    const { key } = this.props.location;
    if (
      this.props.location.pathname.includes("artists") ||
      this.props.location.pathname.includes("contact") ||
      this.props.location.pathname.includes("education") ||
      this.props.location.pathname.length < 2
    ) {
    } else if (!scrollPositions[key]) {
      // never seen this location before
      setTimeout(() => window.scrollTo(0, 0), 5);
    } else {
      // seen it
      window.scrollTo(0, scrollPositions[key]);
      // and again.. in case data has to be loaded 'n shit
      setTimeout(() => window.scrollTo(0, scrollPositions[key]), 150);
    }
    // console.log(JSON.parse(sessionStorage.getItem("scrollPositions")))
  }

  listener = () => {
    scrollPositions[this.props.location.key] = window.scrollY;
    try {
      sessionStorage.setItem(
        "scrollPositions",
        JSON.stringify(scrollPositions)
      );
    } catch (e) {}
    // console.log(JSON.parse(sessionStorage.getItem("scrollPositions")))
  };

  render() {
    return null;
  }
}

export default () => (
  <Location>
    {({ location }) => <ManageScrollImpl location={location} />}
  </Location>
);
